module.exports = __webpack_public_path__ + "media/images/faramia/logo_white-02ca08fcde3fd98c08bca8a280873617.png";